var FIGURE = FIGURE || {};

FIGURE.closedaNAV = function() {
	$(document).on("click", ".onepagenav", function() {
		$("body").removeClass("nav-open");
		$(".nav-mask").fadeOut();
		setTimeout(function() {
			$("body").removeClass("nav-on-page");
		}, 500);
		$(".site-nav").attr("aria-hidden", "true").attr("tabindex", "-1");
		$("#maincontent a, #maincontent button, .site-footer a, .site-footer button, .site-logo, .account-links a, .skip-link").removeAttr("aria-hidden").removeAttr("tabindex");
		$(".open-nav").attr("aria-expanded", "false");
	});
}();
FIGURE.imgAnimation = function() {
	$(window).scroll(function(){
		$('.img-transition').each(function(){
			if ($(this).is(':in-viewport(600)')) {
				$(this).addClass('seen');
			}	
		});	
	});	
}();